import { Injectable, EventEmitter, Component, Output, Renderer2, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ThemeSwitcherService {
    constructor() {
        this.themesSubject = new BehaviorSubject(null);
        this.activeThemeSubject = new BehaviorSubject(null);
        this.themeChange = this.activeThemeSubject.asObservable();
        this.themes = this.themesSubject.asObservable();
    }
    /**
     * @param {?} themes
     * @return {?}
     */
    loadThemes(themes) {
        this._themes = themes;
        this.themesSubject.next(themes);
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    activateTheme(theme) {
        /** @type {?} */
        let t = theme;
        if (typeof t === 'string') {
            /** @type {?} */
            const noTheme = this._themes.some((/**
             * @param {?} th
             * @return {?}
             */
            th => {
                if (th.name === t) {
                    t = th;
                    return true;
                }
                return false;
            }));
            throw new Error('No theme found.');
        }
        this.updateTheme(t);
        this._themes.forEach((/**
         * @param {?} t
         * @return {?}
         */
        t => (t.isActive = t.location === ((/** @type {?} */ (theme))).location)));
        this.themesSubject.next(this._themes);
    }
    /**
     * @private
     * @param {?} theme
     * @return {?}
     */
    updateTheme(theme) {
        /** @type {?} */
        const link = document.querySelector('link[href*="/assets/themes/"][href*="theme.css"]');
        /** @type {?} */
        const newLink = document.createElement('link');
        newLink.rel = 'stylesheet';
        newLink.href = `${theme.location}`;
        newLink.onload = (/**
         * @return {?}
         */
        () => {
            if (link) {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    document.head.removeChild(link);
                }), 10);
            }
            this.activeThemeSubject.next(theme);
        });
        if (link) {
            document.head.insertBefore(newLink, link);
        }
        else {
            document.head.appendChild(newLink);
        }
    }
}
ThemeSwitcherService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ThemeSwitcherService.ctorParameters = () => [];
class ITheme {
    /**
     * @param {?} value
     * @return {?}
     */
    set id(value) {
        this._id = value;
    }
    /**
     * @return {?}
     */
    get id() {
        if (this._id) {
            return this._id;
        }
        else {
            return this.name;
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ThemeSwitcherComponent {
    /**
     * @param {?} themeService
     */
    constructor(themeService) {
        this.themeService = themeService;
        this.themes = [];
        this.themeChange = new EventEmitter();
        this.themeService.themes.subscribe((/**
         * @param {?} themes
         * @return {?}
         */
        themes => {
            if (themes) {
                this.themes = themes;
            }
        }));
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    changeTheme(theme) {
        this.themeService.activateTheme(theme);
    }
}
ThemeSwitcherComponent.decorators = [
    { type: Component, args: [{
                selector: 'theme-switcher-ng',
                template: "<ng-container *ngIf=\"themes\">\n  <div class=\"text-center py-4\">\n    <h2>{{ 'theme-switcher-ng.title' | translate }}</h2>\n  </div>\n  <div class=\"list-group mb-4\">\n    <button type=\"button\" *ngFor=\"let theme of themes\" class=\"list-group-item list-group-item-action\"\n      [class.active]=\"theme.isActive\" (keyup.enter)=\"changeTheme(theme)\" (click)=\"changeTheme(theme)\">\n      {{ theme.name }}\n    </button>\n  </div>\n</ng-container>"
            }] }
];
/** @nocollapse */
ThemeSwitcherComponent.ctorParameters = () => [
    { type: ThemeSwitcherService }
];
ThemeSwitcherComponent.propDecorators = {
    themeChange: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ThemeSwitcherToggleComponent {
    /**
     * @param {?} renderer
     */
    constructor(renderer) {
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.isActive = false;
    }
    /**
     * @return {?}
     */
    toggleDrawer() {
        window.scroll(0, 0);
        this.isActive = !this.isActive;
        /** @type {?} */
        const action = this.isActive ? 'addClass' : 'removeClass';
        this.renderer[action](document.body, 'theme-mode');
    }
}
ThemeSwitcherToggleComponent.decorators = [
    { type: Component, args: [{
                selector: 'theme-switcher-toggle-ng',
                template: "<div (click)=\"toggleDrawer()\" class=\"overlay\" [class.active]=\"isActive\"></div>\n<button type=\"button\" (click)=\"toggleDrawer()\"\n  [attr.aria-label]=\"isActive ? ('theme-switcher-ng.toggle.label.close' | translate) : 'theme-switcher-ng.toggle.label.open' | translate\">\n  <i class=\"ifc-icon-2 p-3 rounded-circle\"></i>\n</button>\n<aside [class.active]=\"isActive\">\n  <i class=\"ifc-icon ifc-palette ifc-icon-4 text-center w-100 mt-4\"></i>\n  <theme-switcher-ng class=\"pb-5\"></theme-switcher-ng>\n</aside>\n"
            }] }
];
/** @nocollapse */
ThemeSwitcherToggleComponent.ctorParameters = () => [
    { type: Renderer2 }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ThemeSwitcherNg {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: ThemeSwitcherNg,
            providers: [
                ThemeSwitcherService
            ]
        };
    }
}
ThemeSwitcherNg.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    TranslateModule
                ],
                declarations: [ThemeSwitcherComponent, ThemeSwitcherToggleComponent],
                exports: [ThemeSwitcherComponent, ThemeSwitcherToggleComponent]
            },] }
];

export { ITheme, ThemeSwitcherComponent, ThemeSwitcherNg, ThemeSwitcherService, ThemeSwitcherToggleComponent as ɵa };
//# sourceMappingURL=inflight-theme-switcher-ng.js.map
